export default __webpack_public_path__ + "static/media/a024-9.5dd7ac9c.svg";